import React from 'react';
import './add_annonce.css'
import CustomModal from '../utils_components/modals/CustomModal';
import {RiCalendarEventFill} from 'react-icons/ri'
import { useForm } from 'react-hook-form';
import {ImUpload} from 'react-icons/im'
import {AiFillEdit} from 'react-icons/ai'
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux';
import { setShowAnnonceModal } from '../../redux/reducers/navigation';
import {uploadBytes,ref, getStorage} from 'firebase/storage'
import { app } from '../../utils/Firebase';

const AddAnnonce = () => {
    const dispatch = useDispatch()

    const showModal = useSelector(state => state.navigation.showAnnonceModal)

    const [isLoading,setIsLoading] = React.useState(false)
    const [selectedImage,setSelectedImage] = React.useState()

    const {register,formState:{errors},setError,handleSubmit} = useForm()

    const submit = (data)=>{
        uploadBytes(ref(getStorage(app),'tester/test.png'),selectedImage).then((result)=>{
            alert('ok')
            console.log(result);
        },error => console.log(error))
    }
    const dataVerification = (data) => {
        if(!selectedImage){
            setError('image',{message:'Veuillez selectionner une image'})
        }
        else{
            submit(data)
        }
    }

    React.useEffect(()=>{
        axios.get('url')
    },[])

    const onImageChange = (event) => {
        if (event.target.files && event.target.files[0]) {
            console.log(event.target.files && event.target.files[0]);
            setSelectedImage(URL.createObjectURL(event.target.files[0]))
        }
    }

    const SelectImageInput = ()=>(
        <input 
        {...register('image')} 
        type="file" placeholder="" 
        className='input-image'
        onChange={(e)=>onImageChange(e)}
        accept='.png,.jpg,.jpeg'
        />
    )

    const setShowModal = (value) => {
        dispatch(setShowAnnonceModal(value))
    }

    return (
        <CustomModal
            title={'Ajouter une annonce'} 
            showModal={showModal} 
            setShowModal={setShowModal}
            icon = {<RiCalendarEventFill color='#DDBB87' size={25} className='me-2' />}>
                
            <form className="row add-annonce-form" onSubmit={handleSubmit(dataVerification)}>
                <div className="col-12 text-start">
                    {/* <p className='text-center text-uppercase fw-bold'>Ajouter une annonce</p> */}
                    
                    <div className="col-12 mt-3">
                        <label>Titre</label>
                        <input {...register('title',{required:'Veuillez saisir un titre'})} type="text" placeholder="" className='input-number' />
                        {errors.title && <p className='error-msg'>{errors.title.message}</p>}
                    </div>
                    <div className="col-12 mt-3">
                        <label>Description</label>
                        <textarea {...register('description')} placeholder="" className='input-number' />
                        {errors.description && <p className='error-msg'>{errors.description.message}</p>}
                    </div>
                    <div className="col-12 mt-3">
                        <label>Image</label>
                        <div className='row p-0 m-0'>
                            {selectedImage ? (
                                <label className='text-center image-selecter'>
                                    <div className='row p-0 m-0'>
                                        <div className="col-2"></div>
                                        <div className="col-8">
                                            <img src={selectedImage} alt="..." />
                                        </div>
                                        <div className="col-2">
                                            <AiFillEdit 
                                                color='white' size={22} 
                                                style={{background:'rgba(0, 0, 0, 0.4)',borderRadius:'3px'}} />
                                        </div>
                                    </div>
                                    <SelectImageInput />
                                </label>
                            ):(
                                <label className='text-center image-selecter'>
                                    <div className="pt-2 ">
                                        <ImUpload color='rgba(0, 0, 0, 0.2)' size={40} />
                                        <p className='mt-3'>Selectionnez une image</p>
                                    </div>
                                    <SelectImageInput/>
                                </label>
                            )}
                            {errors.image && !selectedImage && <p className='error-msg'>{errors.image.message}</p>}
                        </div>
                    </div>
                    
                    <div className="col-12 mt-4">
                        <button disabled={isLoading} className='submit-btn row p-0 m-0 align-items-center'>
                            <div className="col-2"></div>
                            <div className="col-8">
                                Ajouter
                            </div>
                            <div className="col-2 pt-1">
                                {isLoading && <div class="spinner-border ms-auto" role="status" aria-hidden="true"></div>}    
                            </div>
                        </button>
                    </div>
                </div>
            </form>
        </CustomModal>
    );
};

export default AddAnnonce;